import {
  fetchStaticPageData,
  StaticPage,
} from '@dreamstack/accentro-contentful'
import { PropertyContact } from '@dreamstack/feature-components'
import { css, styled } from 'twin.macro'
import { defaultQueries } from '../lib/defaultQueries'
import { getStaticPropsPlus } from '../lib/getStaticPropsPlus'

// Custom CSS on for the entire Page
const StyledPage = styled(StaticPage)(() => [
  // Teal Text Heading Background
  css`
    h2 {
      color: #2b2d36;
      display: block;
      --padding-x: 8px;
      --padding-y: 4px;
      --padding-color: #00ffd0;
      padding: 0 var(--padding-x);
      /* line-height: 1.2em; */
      span {
        box-shadow: calc(1 * var(--padding-x)) calc(1 * var(--padding-y)) 0
            var(--padding-color),
          calc(-1 * var(--padding-x)) calc(-1 * var(--padding-y)) 0
            var(--padding-color),
          calc(-1 * var(--padding-x)) calc(1 * var(--padding-y)) 0
            var(--padding-color),
          calc(1 * var(--padding-x)) calc(-1 * var(--padding-y)) 0
            var(--padding-color);
        background-color: var(--padding-color);
        box-decoration-break: clone;
      }
    }
  `,
  // Spacing between first p and heading
  css`
    p:first-child + h2 {
      margin-top: 0;
    }
  `,
])

export default function Home() {
  return (
    <>
      <StyledPage slug={'immoscout24'}>
        <PropertyContact
          broker_email="partner@accentro.de"
          broker_first_name=""
          broker_last_name="ACCENTRO Real Estate AG"
          broker_phone="+49(30) 887 181 7628"
        />
      </StyledPage>
    </>
  )
}

export const getStaticProps = getStaticPropsPlus({
  queries: defaultQueries,
  getProps: async ({ apolloClient }) => {
    const staticPageData = await fetchStaticPageData({
      apolloClient,
      slug: 'immoscout24',
    })

    // Show 404 when page not published
    if (!staticPageData) {
      return {
        props: {},
        notFound: true,
      }
    }
  },
})
